module.exports = __webpack_public_path__ + "static/hellwasp-883c4583e4d8b8edb6dbbae7afbd94ad.jpeg";